// extracted by mini-css-extract-plugin
export default {"container":"CreateEstimateTagsTab_container__Z8IYw","title":"CreateEstimateTagsTab_title__HKZ0Y","formFooter":"CreateEstimateTagsTab_formFooter__n4vQM"};